<template>
  <UApp>
    <NuxtLayout/>
  </UApp>
</template>
